exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "span[data-v-937fcd12]{color:inherit}", "", {"version":3,"sources":["C:/Users/jusma/Projects/lowco.tv/src/components/global/StreamTimes.vue"],"names":[],"mappings":"AACA,sBACE,aAAe,CAChB","file":"StreamTimes.vue","sourcesContent":["\nspan[data-v-937fcd12] {\n  color: inherit;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-937fcd12","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/global/StreamTimes.vue
// module id = 1042
// module chunks = 2 3